module.exports = __webpack_public_path__ + "img/whatsapp.36fb1c47.png";